export default __webpack_public_path__ + "static/media/student.b63b9760.svg";